
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".5","width":"26","height":"26","rx":"13","fill":"#122546"}}),_c('path',{attrs:{"d":"M19.924 8.202l-.959-.401v6.46l1.739-4.192a1.432 1.432 0 00-.78-1.867zm-13.95 2.647l3.548 8.549a1.439 1.439 0 001.295.901c.186 0 .379-.036.565-.114l5.272-2.182c.537-.222.866-.751.88-1.28a1.639 1.639 0 00-.093-.58l-3.577-8.55A1.398 1.398 0 0012.57 6.7c-.186 0-.372.043-.55.108L6.753 8.989a1.427 1.427 0 00-.78 1.86zM17.526 8.13a1.43 1.43 0 00-1.43-1.43h-1.038l2.468 5.966","fill":"#fff"}})])
          )
        }
      }
    